// Shared sport-options (Lesson 38: single source of truth).
// Previously a local const in SettingsGeneral.tsx; extracted in delspår 3b so the
// activity wizard (SportPill grid) and admin settings consume the same list
// instead of maintaining two divergent sport-arrays.

export interface SportOption {
  value: string;
  label: string;
}

export const SPORT_OPTIONS: readonly SportOption[] = [
  { value: "padel", label: "Padel" },
  { value: "tennis", label: "Tennis" },
  { value: "golf", label: "Golf" },
  { value: "badminton", label: "Badminton" },
  { value: "squash", label: "Squash" },
  { value: "pickleball", label: "Pickleball" },
  { value: "generic", label: "Annan" },
] as const;

// Note: the activity wizard derives the club's *active* sports from courts.sport_type
// (distinct per org) rather than a static list — see Step1SportType. SPORT_OPTIONS only
// supplies label + icon for a given sport slug.
